import { Header } from '@/components/commons/header'
import { User01Icon } from '@/components/ui/icons'
import { useAuthStore } from '@/features/auth/store/store.ts'
import { useTranslation } from '@/translations/i18n'

export const Welcome = () => {
	const { t } = useTranslation()
	const user = useAuthStore((state) => state.user)

	return (
		<>
			<title>{t('welcome:page_title_meta')}</title>
			<div className='grid h-full grid-rows-[auto_1fr] overflow-hidden'>
				<Header />
				<div className='grid h-full grid-rows-[1fr] items-center justify-center overflow-hidden bg-neutral-50'>
					<div className='flex w-[392px] flex-col items-center text-center'>
						<User01Icon size={32} />
						<section className='py-6'>
							<h1 className='font-semibold text-display-xs text-neutral-900'>
								{t('welcome:title', {
									username: user?.first_name ?? user?.email
								})}
							</h1>
							<p className='text-neutral-600 text-xl'>
								{t('welcome:subtitle')}
							</p>
						</section>
					</div>
				</div>
			</div>
		</>
	)
}

Welcome.displayName = 'Welcome'
